<template>
  <div>
    <AppTooltip>
      <template #activator="{ props }">
        <app-button
          v-bind="props"
          type="icon"
          @click="isOpen = true"
        >
          <app-material-icon name="delete" />
        </app-button>
      </template>
      <span>{{t('tooltipDelete')}}</span>
    </AppTooltip>
    <AppDialog :is-open="isOpen"
               :cancel-disabled="deleteGroupLoading"
               :ok-loading="deleteGroupLoading"
               @ok="prepareDeleteGroup"
               @cancel="isOpen = false"
    >
      <template #title>{{ t('deleteGroup') }}</template>
      <template #body>
        <p>{{ t('deleteGroupText.text1', {groupName: groupToDelete.name}) }}</p>
        <p>{{ t('deleteGroupText.text2') }}</p>
      </template>
    </AppDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { useTranslation } from '@/common/utils/translation'

export default {
  name: 'DeleteGroup',
  components: { AppDialog, AppTooltip },
  setup () {
    return useTranslation({ keyPrefix: 'project.members.dialogs.GroupDeleteDialog' })
  },
  props: {
    groupToDelete: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      isOpen: false,
    }
  },
  computed: {
    ...mapState('groups', ['deleteGroupLoading']),
  },
  methods: {
    ...mapActions('groups', ['DELETE_GROUP']),
    prepareDeleteGroup () {
      this.DELETE_GROUP({ mnemo: this.$route.params.mnemo, groupId: this.groupToDelete.id })
        .then(() => {
          toast.success(this.t('deleteGroupSuccess'))
        })
        .catch(error => {
          if (error.response?.data?.error === 'ERR_GROUP_NOT_EMPTY') {
            toast.error(this.t('deleteGroupNotEmpty'))
          } else {
            toast.error(this.t('deleteGroupError'))
          }
        })
        .finally(() => {
          this.isOpen = false
        })
    },
  },
}
</script>
